import { render } from "./UploadProof.vue?vue&type=template&id=d91ecb74"
import script from "./UploadProof.vue?vue&type=script&lang=js"
export * from "./UploadProof.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__